var $ = require('jquery');

const $colorSelect = $('input.js-colors');
const $sizeSelect = $('input.js-sizes');
const $variantSelect = $('select.js-variants');
const $submitButton = $('input.js-submit');

export function init_product() {


    // If the color select exists, add an on change handler to it
    if ($colorSelect.length > 1) {
        $submitButton.attr('disabled', 'disabled');
        $colorSelect.on('change', function(e) {
            updateSelectStatus('color');
        });
    }

    // If the size select exists, add an on change handler to it
    if ($sizeSelect.length > 1) {
        $submitButton.attr('disabled', 'disabled');
        $sizeSelect.on('change', function(e) {
            updateSelectStatus('size');
        });
    }

    // Disable the colors and sizes that are completely sold out 
    disableSoldOutOptions();
}

/**
 * Triggered when one of the attribute dropdowns is selected. 
 */
function updateSelectStatus(attribute) {

    let color = $('input.js-colors:checked').val();
    let size = $('input.js-sizes:checked').val();

    if ($colorSelect.length > 0 && $sizeSelect.length > 0) {
        if (attribute === 'color') {
            disableUnavailableOptions('color', color);
        } else if (attribute === 'size') {
            disableUnavailableOptions('size', size);
        }

        selectVariant(color, size);
    } else {
        if (attribute === 'color') {
            selectVariant(color, '');
        } else {
            selectVariant('', size);
        }
    }
}

/**
 * Selects a variant based on the value of the two attribute dropdowns
 */
function selectVariant(color, size) {
    var $variantOptions = $variantSelect.find('option');
    var $selectedOption = null;

    $variantSelect.val('');
    $variantOptions.each(function(i) {
        if (String($(this).data('color')) === color && String($(this).data('size')) === size) {
            $variantSelect.val($(this).attr('value'));
            $selectedOption = $(this);
        }
    });

    updatePrice($selectedOption);
}

/**
 * Based on the attribute and value the user selected, disable all options
 * in the other dropdown that don't have a variant with this value.
 */
function disableUnavailableOptions(attribute, val) {
    var $variantOptions = $variantSelect.find('option');
    var reverseAttribute = attribute === 'color' ? 'size' : 'color';

    if (attribute === 'color') {
        $submitButton.attr('disabled', 'disabled');

        $colorSelect.each(function() {
            if ($(this).val() === val) {
                $(this).closest('li').find('label').removeClass('disabled')
            }else {
                $(this).closest('li').find('label').addClass('disabled')
            }
        });
        $sizeSelect.each(function() {
            $(this).prop('checked', false);
            $(this).closest('li').find('label').removeClass('disabled')
        });

    } else {
        $colorSelect.each(function() {
            $(this).closest('li').find('label').removeClass('disabled');
        });

    }

    if (val!=='') {
        var available = [];
        $variantOptions.each(function(i) {
            if ($(this).data(attribute) === val && !$(this).is(':disabled')) {
                available.push($(this).data(reverseAttribute));
            }
        });

        var $otherSelect = attribute === 'color' ? $sizeSelect : $colorSelect;
        $otherSelect.each(function() {
            var $opt = $(this);
            if (($.inArray($opt.attr('value'), available) !== -1) || ($opt.attr('value') === '')) {
                $(this).closest('li').find('label').removeClass('disabled');
            } else {
                $(this).closest('li').find('label').addClass('disabled');
            }
        });
    }
}

/**
 * Disables sold out options. Loops over the two selects and checks if
 * there is a variant in the variants dropdown that is not out of stock.
 */
function disableSoldOutOptions() {
    var $variantOptions = $variantSelect.find('option');

    if ($colorSelect.length > 0) {
        $colorSelect.find('option').each(function() {
            var $opt = $(this);
            var found = false;

            $variantOptions.each(function(i) {
                if (($(this).data('out-of-stock') !== true) && (String($(this).data('color')) === $opt.val())) {
                    found = true;
                }
            });

            if (!found) {
                $opt.attr('disabled', 'disabled');
            }
        });
    }

    if ($sizeSelect.length > 0) {
        $sizeSelect.find('option').each(function() {
            var $opt = $(this);
            var found = false;

            $variantOptions.each(function(i) {
                if (($(this).data('out-of-stock') !== true) && (String($(this).data('size')) === $opt.val())) {
                    found = true;
                }
            });

            if (!found) {
                $opt.attr('disabled', 'disabled');
            }
        });
    }
}

/**
 * Updates the price based on the variant that was selected. You'll probably
 * want to do some currency formatting in here, and maybe remove the sale
 * price if it's the same as the full price.
 */
function updatePrice($option) {

    if ($option !== null) {
        var $priceFull = $('[data-variant-price-full]');

        if ($priceFull.length > 0) {
            $priceFull.text($option.data('price'));
        }

        $submitButton.removeAttr('disabled');
    }
}



// WEBPACK FOOTER //
// ./resources/assets/js/scripts/product.js